var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import MultiSelect from '@kenshooui/react-multi-select';
import { Editor } from '@tinymce/tinymce-react';
import { AutoComplete } from 'primereact/autocomplete';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/components/button/Button';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { SelectButton } from 'primereact/selectbutton';
import * as React from 'react';
import NotosService from '../../../classes/notos.service';
import Config from '../../../config/config';
import ImageControl from '../ImageControl/ImageControl';
import './Input.css';
var input = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var inputElement = null;
    var label = null;
    var addonLeft = null;
    var addonRight = null;
    var validationError = null;
    var inputClasses = '';
    var wrapperClass = '';
    var labelExtraClass = '';
    if (props.wrapperClass) {
        wrapperClass = props.wrapperClass;
    }
    if (props.labelExtraClass) {
        labelExtraClass = props.labelExtraClass;
    }
    if (props.label) {
        label = React.createElement("label", { className: 'modalLabels ' + labelExtraClass }, props.label);
    }
    if (props.addon) {
        var addonContent = null;
        if (props.addon.icon) {
            addonContent = React.createElement("i", { className: props.addon.icon });
        }
        else if (props.addon.text) {
            addonContent = props.addon.text;
        }
        if (props.addon.position === 'left') {
            addonLeft = (React.createElement("div", { className: "input-group-prepend" },
                React.createElement("span", { className: "input-group-text" }, addonContent)));
        }
        if (props.addon.position === 'right') {
            addonRight = (React.createElement("div", { className: "input-group-append" },
                React.createElement("span", { className: "input-group-text" }, addonContent)));
        }
    }
    if (props.invalid && props.shouldValidate && props.touched) {
        inputClasses += ' invalid';
    }
    if (props.invalid && props.touched) {
        validationError = React.createElement("p", { className: "errorMsg" }, props.errorMsg);
    }
    switch (props.elementType) {
        case 'input':
            inputElement = (React.createElement("input", __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed, onBlur: props.blur, className: "form-control " + inputClasses + " " + (addonRight !== null ? 'border-radius-right-none' : ''), maxLength: props.maxLength, disabled: props.elementConfig.readOnlyInput ||
                    (props.disabledIds && props.disabledIds.includes(props.id)) // Check if the ID is in disabledIds
             })));
            break;
        case 'textarea':
            inputElement = (React.createElement("textarea", __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed, onBlur: props.blur, className: 'form-control' + inputClasses, maxLength: props.maxLength })));
            break;
        case 'autocomplete':
            // use only with {label, value} types of suggestions
            inputElement = (React.createElement(React.Fragment, null,
                React.createElement(AutoComplete, __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed, suggestions: props.suggestions, multiple: props.multiple, completeMethod: props.completeMethod, onBlur: props.blur, field: "label", className: "form-control " + inputClasses + " " + (addonRight !== null ? 'border-radius-right-none' : ''), maxLength: props.maxLength, disabled: props.elementConfig.readOnlyInput ||
                        (props.disabledIds && props.disabledIds.includes(props.id)) // Check if the ID is in disabledIds
                 })),
                props.deleteButton === true ? (React.createElement(Button, { type: "button", className: "searchDelete", id: 'delete_' + props.id, style: {
                        background: '#f86c6b',
                        border: 'none',
                        position: 'absolute',
                        right: '-40px',
                        top: '2px',
                    }, onClick: props.deleteButtonAction, icon: "fa fa-times", tooltip: 'Delete', tooltipOptions: { position: 'top' } })) : ('')));
            break;
        case 'dropdown':
            inputElement = (React.createElement(Dropdown, __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed, disabled: props.elementConfig.readOnlyInput ||
                    (props.disabledIds && props.disabledIds.includes(props.id)) // Check if the ID is in disabledIds
             })));
            break;
        case 'inputSwitch':
            inputElement = (React.createElement(InputSwitch, { id: props.id, onChange: props.changed, checked: props.value === 'true', className: 'mfa-button', disabled: (props.disabledIds && props.disabledIds.includes(props.id)) // Check if the ID is in disabledIds
             }));
            break;
        case 'customDropdown':
            inputElement = (React.createElement(Dropdown, __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed, itemTemplate: props.itemTemplate })));
            break;
        case 'editor':
            inputElement = (React.createElement(React.Fragment, null,
                React.createElement(Editor, { value: props.value, id: props.id, apiKey: Config.tinyMCEKey, init: {
                        width: '100%',
                        height: 500,
                        menubar: false,
                        plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                        ],
                        toolbar: ' link | media image | formatselect | bold italic alignleft aligncenter alignright  alignjustify | code |  \
                 backcolor | bullist numlist outdent indent',
                    }, onEditorChange: function (content) { return props.changed({ target: { value: content } }); } })));
            break;
        case 'image':
            inputElement = (React.createElement(ImageControl, __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed })));
            break;
        case 'buttonModal':
            inputElement = (React.createElement(React.Fragment, null,
                React.createElement(Button, { type: "button", className: "builderEditor", id: props.id, onClick: props.modalButtonAction, label: props.buttonModalText }),
                React.createElement("div", { id: 'modalButtonText', style: {
                        minWidth: '320px',
                        background: '#F7F8F9',
                        width: '100%',
                        marginTop: '15px',
                        padding: '10px'
                    }, dangerouslySetInnerHTML: { __html: props.modalhtmlContent } })));
            break;
        case 'dropdown-groups':
            var elOptions = props.elementConfig.options;
            var options = elOptions.map(function (optGroup, key) {
                var groupOptions = optGroup.value.map(function (opt) {
                    return (React.createElement("option", { value: opt.value, key: opt.value }, opt.label));
                });
                return (React.createElement("optgroup", { key: key, label: optGroup.id }, groupOptions));
            });
            inputElement = (React.createElement("select", __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed }),
                React.createElement("option", { value: "", disabled: true, selected: true }, "Select your option"),
                options));
            break;
        case 'datepicker':
            inputElement = (React.createElement(Calendar, __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed, onBlur: props.blur, onFocus: props.onFocus, dateFormat: ((_a = props.elementConfig) === null || _a === void 0 ? void 0 : _a.dateFormat) || NotosService.datepickerFormat, timeOnly: (_b = props.elementConfig) === null || _b === void 0 ? void 0 : _b.timeOnly, showTime: (_c = props.elementConfig) === null || _c === void 0 ? void 0 : _c.showTime, hourFormat: (_d = props.elementConfig) === null || _d === void 0 ? void 0 : _d.hourFormat, showIcon: true, viewDate: props.viewDate, onViewDateChange: props.onViewDateChange })));
            break;
        case 'timepicker':
            inputElement = (React.createElement(Calendar, __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed, onBlur: props.blur, onFocus: props.onFocus, timeOnly: true, showTime: (_e = props.elementConfig) === null || _e === void 0 ? void 0 : _e.showTime, hourFormat: (_f = props.elementConfig) === null || _f === void 0 ? void 0 : _f.hourFormat, showIcon: true, onViewDateChange: props.onViewDateChange })));
            break;
        case 'select-button':
            inputElement = (React.createElement(SelectButton, __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed })));
            break;
        case 'checkbox':
            inputElement = (React.createElement(Checkbox, __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed, checked: props.value, className: 'mfa-button' })));
            break;
        case 'multiselect':
            inputElement = (React.createElement(MultiSelect, __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed, withGrouping: true, height: 150, responsiveHeight: '200px', itemType: props.itemType })));
            break;
        default:
            inputElement = (React.createElement("input", __assign({}, props.elementConfig, { value: props.value, id: props.id, onChange: props.changed, onBlur: props.blur, className: 'form-control' + inputClasses, maxLength: props.maxLength })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'input-group mb-3 ' + wrapperClass },
            label,
            addonLeft,
            inputElement,
            addonRight,
            validationError)));
};
export default input;



//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Input/Input.tsx
// module id = 12
// module chunks = 0